
import { defineComponent, toRefs } from "vue";
import { titleCase } from "@/util/helpers";
import { GDT } from "@/types";

export default defineComponent({
  name: "DataSourceFilter",
  props: {
    filter: {
      type: Object as () => GDT.DataFilter,
      required: true,
    },
  },
  setup: (props) => ({
    ...toRefs(props.filter as GDT.DataFilter),
    titleCase,
    filterOperatorSymbol: (o: GDT.FilterOperator) =>
      GDT.filterOperators.get(o)?.symbol || "",
    filterOperatorDescription: (o: GDT.FilterOperator) =>
      GDT.filterOperators.get(o)?.name || "",
  }),
});
